import { StrictMode } from "react";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app";
import "./styles/global.css";

(globalThis as typeof globalThis & { React?: typeof React }).React = React;

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element with id "root" was not found.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
